module.exports = __webpack_public_path__ + "static/media/r372.dcce734b.jpg";